module.exports = __webpack_public_path__ + "images/emoji/seven.405b700ffa88f763a6ec.png";